// AIzaSyAgzbkGahzTEmHMOTh9YCsolasPCECDdv0
// https://www.youtube.com/@KALAMBOOR
import FooterOne from '../Footer/FooterOne';
import Header from '../Header/HeaderOne';
import { pageTitle } from '../PageTitle';
import React, { useEffect, useMemo, useState } from 'react';
import Preloader from '../Preloader/Preloader';
import YouTubeEvents from './YouTubesFetcher';
const MediaPage = () => {
    pageTitle("MEDIA")
    const [isLoading, setIsLoading] = useState(true)
    const channelNames = ["pubgmobileesports"]
    return <>
        <YouTubeEvents channelNames={channelNames} />
        {
            !isLoading ? <>
                <Header></Header>
                    {/* <div className="services__page section-padding">
                        <div className="container">
                            <div className="row mb-30">
                                <div className="col-xl-6 col-lg-8">
                                    <div style={{marginBottom: '20px'}} className="services__page-title lg-t-center">
                                        <span className="subtitle">rating</span>
                                        <h2>Amateur rating</h2>
                                    </div>
                                    <div className="services__page-title lg-t-center">
                                        <h2>Selected filter - {filterState}</h2>
                                    </div>
                                    <div className="services__page-title lg-t-center">
                                        <button style={{marginRight: '10px'}} onClick={() => setFilterState('mvp')}>MVP</button>
                                        <button style={{marginRight: '10px'}} onClick={() => setFilterState('kills')}>Kills</button>
                                        <button style={{marginRight: '10px'}} onClick={() => setFilterState('k/d')}>KD</button>
                                    </div>
                                </div>
                                <div style={{marginTop: '10px'}} >
                                    <p>Search</p>
                                    <input placeholder='NickName' style={{backgroundColor: 'transparent'}} type="text" value={searchInputState} onChange={e => setSearchInputState(e.target.value)} />
                                </div>
                            </div>
                            <div className="row">
                                {filteredRating.map((item, id)=>(
                                    <>
                                        <div className="col-xl-12" key={id}>
                                            <div className="services__page-item media-rating-container">
                                                <div className="services__page-item-left">
                                                    <p style={{marginRight: '20px'}}>{id + 1}</p>
                                                    <div className="services__page-item-left-icon">
                                                        <img src={item.teamLogo == '' ? '/images/cup.svg' : item.teamLogo == 'none' ? '/images/cup.svg' : item.teamLogo} alt="" />
                                                    <div className="services__area-item-icon-one">
                                                        <img src={item.imageLink == '' ? '/images/cup.svg' : item.imageLink == 'none' ? '/images/cup.svg' : item.imageLink} alt="" />
                                                    </div>
                                                    </div>
                                                    <div className="services__page-item-left-content">
                                                        <h4><p>{item.name}</p></h4>
                                                    </div>
                                                </div>
                                                <div className='pr-card-box'>
                                                    <div className="pr-carg-rating-container">
                                                        <p>MVP - {item.mvp}</p>
                                                        <span className="pr-card-rating-stick">
                                                            <div style={{ backgroundColor: (item.mvp / firstValues.mvp) * 100 < 25 ? "red" : (item.mvp / firstValues.mvp) * 100 < 75 ? '#ffc800' : (item.mvp / firstValues.mvp) * 100 < 100 ? 'rgb(3 253 69)' : 'rgb(3 253 69)', height: '100%', width: `${(item.mvp / firstValues.mvp) * 100}%` }}></div>
                                                        </span>
                                                    </div>
                                                    <div className="pr-carg-rating-container">
                                                        <p>Kills - {item.kills}</p>
                                                        <span className="pr-card-rating-stick">
                                                            <div style={{ backgroundColor: (item.kills / firstValues.kills) * 100 < 25 ? "red" : (item.kills / firstValues.kills) * 100 < 75 ? '#ffc800' : (item.kills / firstValues.kills) * 100 < 100 ? 'rgb(3 253 69)' : 'rgb(3 253 69)', height: '100%', width: `${(item.kills / firstValues.kills) * 100}%` }}></div>
                                                        </span>
                                                    </div>
                                                    <div className="pr-carg-rating-container">
                                                        <p>K/D - {(item.kd / item.kd).toFixed(2)}</p>
                                                        <span className="pr-card-rating-stick">
                                                            <div style={{ backgroundColor: ((item.kd / item.kd) / firstValues.kd) * 100 < 25 ? "red" : ((item.kd / item.kd) / firstValues.kd) * 100 < 75 ? '#ffc800' : ((item.kd / item.kd) / firstValues.kd) * 100 < 100 ? 'rgb(3 253 69)' : 'rgb(3 253 69)', height: '100%', width: `${((item.kd / item.kd) / firstValues.kd) * 100}%` }}></div>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="services__page-item-right">
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ))}
                            </div>
                        </div>
                    </div> */}
                <FooterOne></FooterOne>        
            </> : <Preloader />
        }
    </>;
};

export default MediaPage;